import Vue from "vue";
import router from "@/routers";
import indexApi from "@/api/index/indexApi.js";
import orderAPI from '@/api/index/orderApi.js'

export function paypal(orderGroupId) {
  window.paypal
    .Buttons({
      createOrder: function() {
        let params = {
          payType: "PAYPAL",
          payChannel: "PAYPAL",
          orderGroupId: orderGroupId
        };
        return indexApi
          .orderPayNew(params)
          .then(function(res) {
            if (!res.data.code) {
              return res.data.data.payId;
            } else {
              new Vue().$message.error(res.data.message);
            }
          })
          .catch(err => {
            console.log("orderPayNew ===", err);
          });
      },

      // Finalize the transaction
      onApprove: function (data) {
        return indexApi
          .orderCaptureInfo({ payId: data.orderID })
          .then(function(res) {
            if (!res.data.code) {
              router.push({
                path: "/paymentResult",
                query: { type: "paymentSuccessful" }
              });
            } else {
              new Vue().$message.error(res.data.message);
              router.push({
                path: "/paymentResult",
                query: { type: "paymentFailed" }
              });
            }
            sessionStorage.removeItem("checkedList");
          })
          .catch(err => {
            console.log("orderCaptureInfo ===", err);
          });
      }
    })
    .render("#paypal-button-container");
}

export function paypal2(productItems, fn, self, isSure) {
  window.paypal
    .Buttons({
      style: {
        layout: 'horizontal',
        color: 'gold',
        shape: 'rect',
        height: 40,
        width: 320,
        padding: 30,
        tagline: false
      },
      // Set up the transaction
      onShippingChange: function(data, actions) {
        return actions.resolve();
      },
      createOrder: function () {
        let items = [];
        (self.shoppingList || []).forEach(shop => {
            let productsList = shop.items
            let itemsSub = {
              products: []
            }
            productsList.forEach(products => {
              if (products) {
                let productItems = products.productItems
                productItems.forEach(product => {
                  if (product.checked) {
                    itemsSub.products.push({
                      productId: product.productSpec.productId + '',
                      productSpecId: product.productSpec ? product.productSpec.id : '',
                      quantity: product.quantity + '',
                      freightTemplateId: product.freightTemplateId,
                      customField: JSON.stringify(product.customField || []),
                    })
                  }
                })
              }
            })
            items.push(itemsSub)
        })
        let productItems2 = isSure ? productItems : JSON.stringify((items[0] || {}).products)
        return orderAPI
          .prePayOrder({
            productItems: productItems2
          })
          .then(function(res) {
            if (!res.data.code) {
              return res.data.data.payId;
            } else {
              new Vue().$message.error(res.data.message);
            }
          })
          .catch(err => {
            console.log("orderPayNew ===", err);
          });
      },
      onApprove: function(data) {
        return indexApi
          .getPaypalAddress({ payId: data.orderID })
          .then(function(res) {
            if (!res.data.code) {
              fn(res.data.data, data.orderID)
            } else {
              new Vue().$message.error(res.data.message);
            }
          })
          .catch(err => {
            console.log("orderCaptureInfo ===", err);
          });
      }
    })
    .render("#paypal-button-container");
}
